<template>
  <form
    :id="internalId"
    data-sb-regression="sb-form"
    v-bind="attrs"
    class="sb-form"
    v-on="attrs"
  >
    <!--
      @slot form elements, components, or HtmlElements as children of the component
    -->
    <slot
      v-if="usingScoped"
      :validations="validations"
    />
    <slot v-else />
  </form>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import uuid from '@src/utils/uuid';
import SbFormMixin from '@src/components/Form/utils/sbFormMixin';
import SbFormModel from '@src/components/Form/utils/sbFormModel';

// TODOJB: Standardized general error messaging to be exposed in next version.

/**
 * This is a form wrapper. It should be used in conjunction with fields to record some data from a user and submit it.
 */
export default {
  name: 'SbForm',
  mixins: [SbFormMixin],
  provide() {
    return {
      sbForm: this.sbForm,
      sbValidator: this.internalValidator,
      onChange: this.onChange,
    };
  },
  model: {
    prop: 'model',
    event: 'form-changed',
  },
  props: {
    /**
     * Style variation to give additional meaning.
     * `default|warning|error|valid`
     */
    variation: {
      type: String,
      default: 'default',
      validator: (value) => {
        return value.match(/(default|warning|error|valid)/);
      },
    },
    /**
     * Use the default form validations.
     */
    useDefaultValiations: {
      type: Boolean,
      default: false,
    },
    /**
     * Validator config object to tell the form how and when to validate its fields.
     */
    validator: {
      type: Object,
      default: null,
      required: false,
    },
    /**
     * html id of the form element. default will be set as the Vue component uuid.
     */
    id: {
      type: String,
      default: null,
    },
    /**
     * Value prop to support v-model syntax
     */
    // MAYBE REMOVE
    model: {
      type: Object,
      default: null,
      required: false,
    },
  },
  emits: [
    /**
     * Emitted with HTML event when form changes
     */
    'onChange',
    /**
     * Emitted with the data filled out on the form
     */
    'form-changed',
    /**
     * Triggered with the validated flag
     */
    'onChangeValidated',
    /**
     * Emitted with the validated form data when form is submitted
     */
    'onsubmit',
  ],
  data: () => ({
    sbForm: cloneDeep(SbFormModel),
    internalId: null,
  }),
  computed: {
    usingScoped() {
      return this.$slots.default && this.$slots.default();
    },
    attrs() {
      const attrs = cloneDeep(this.$attrs);
      attrs.novalidate = !this.useDefaultValiations;
      attrs.submit = this.submit;

      return attrs;
    },
  },
  mounted() {
    this.setId();
  },
  methods: {
    setId() {
      this.internalId = this.id || uuid();
    },
  },
};
</script>

<style lang="scss">

</style>
